module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('bloco', {
    staticClass: "-padding-desktop",
    attrs: {
      "id": "categorias"
    }
  }, [_c('header', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('titulo', {
    staticClass: "-withbar -upper"
  }, [_vm._v("Documentos")]), _c('p', [_vm._v("Aqui você encontrará os documentos para download")])], 1), _c('div', {
    staticClass: "conteudo",
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [(!_vm.naoTemCategorias) ? _c('lista', {
    staticClass: "categorias",
    attrs: {
      "itens": _vm.categorias,
      "rota": 'Documentos',
      "icone": 'pasta'
    }
  }) : _vm._e()], 1), (_vm.naoTemCategorias) ? _c('template', {
    slot: "feedback"
  }, [_c('br'), _c('mensagem', {
    staticClass: "-warn"
  }, [_c('p', [_vm._v("Nenhum documento foi encontrado no momento")])])], 1) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b43ee62e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/vue/modules/Categorias.vue
// module id = 510
// module chunks = 0